import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiTreatmentsSectionDTO,
  TreatmentsSectionDTO,
} from "@lib/strapi/dtos/components/sections/treatmentsSection.dto";
import { parseStrapiContent } from "@lib/strapi/content";

export class TreatmentsSectionService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiTreatmentsSectionDTO,
  ): Promise<TreatmentsSectionDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new TreatmentsSectionDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.heading = strapiData.heading;
    dto.intro = await parseStrapiContent(strapiData.intro);
    dto.layout = strapiData.layout;
    dto.source = strapiData.source;
    dto.slugs = strapiData.slugs;
    return dto;
  }
}
